import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button", "label"];

  connect() {
    if (!navigator.clipboard && !window.isSecureContext && this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden");
    }
  }

  async copy(event) {
    event.preventDefault();

    try {
      const text = this.sourceTarget.value || this.sourceTarget.textContent;

      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for older browsers
        this.fallbackCopyTextToClipboard(text);
      }

      this.showSuccess();
    } catch (err) {
      console.error("Failed to copy text: ", err);
      this.fallbackCopyTextToClipboard(
        this.sourceTarget.value || this.sourceTarget.textContent,
      );
    }
  }

  fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        this.showSuccess();
      }
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }

  showSuccess() {
    this.dispatch("copied");

    if (this.hasLabelTarget) {
      const originalText = this.labelTarget.innerText;
      this.labelTarget.innerText = "✓ Copied";

      // Reset the text after 2 seconds
      setTimeout(() => {
        this.labelTarget.innerText = originalText;
      }, 2000);
    }
  }
}
